import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import axios from "axios";
import "../../styles/PabrikT.css";

const PabrikT = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [purchaseData, setPurchaseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [tanggal, setTanggal] = useState("");

  // Helper konversi waktu UTC/GMT ke WIB (GMT+7)
  const formatToWIB = (dateString, withTime = false) => {
    if (!dateString || dateString === "-") return "-";

    let isoString = String(dateString).trim();
    if (!isoString.endsWith("Z") && !isoString.includes("+")) {
      isoString = isoString.replace(" ", "T") + "Z";
    }

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return dateString;

    const options = {
      timeZone: "Asia/Jakarta",
      day: "numeric",
      month: "short",
      year: "numeric",
      ...(withTime && {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }),
    };

    return (
      new Intl.DateTimeFormat("id-ID", options).format(date) +
      (withTime ? " WIB" : "")
    );
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/riwayat",
        { withCredentials: true }
      );
      setPurchaseData(response.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "Gagal memuat data transaksi.", "error");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(purchaseData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPurchaseData = purchaseData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Error during logout:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const openModal = (trackingId) => {
    Swal.fire({
      title: "Update Berat Akhir Sawit",
      input: "number",
      inputLabel: "Masukkan Berat Akhir Sawit (kg)",
      inputPlaceholder: "Contoh: 1000",
      showCancelButton: true,
      confirmButtonText: "Update",
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
      preConfirm: (beratAkhir) => {
        if (!beratAkhir || isNaN(beratAkhir) || Number(beratAkhir) <= 0) {
          Swal.showValidationMessage("Berat akhir sawit harus berupa angka valid!");
          return false;
        }
        return beratAkhir;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleUpdateBerat(result.value, trackingId);
      }
    });
  };

  const handleUpdateBerat = async (beratAkhir, trackingId) => {
    const waktuMasuk = new Date().toISOString().slice(0, 19).replace("T", " ");

    const confirmRes = await Swal.fire({
      title: "Konfirmasi Pembaruan Berat",
      text: `Tracking ID: ${trackingId}\nApakah Anda yakin ingin memperbarui berat akhir sawit menjadi ${beratAkhir} kg?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Perbarui!",
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
    });

    if (confirmRes.isConfirmed) {
      try {
        const response = await axios.post(
          "https://c-greenproject.org:7500/update_berat_sawit",
          {
            tracking_id: trackingId,
            berat_final: beratAkhir,
            waktu_masuk: waktuMasuk,
          },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const { message, kapasitas_tersedia, harga_per_kg, total_harga } = response.data;

        Swal.fire({
          title: "Berhasil!",
          html: `${message}<br><br><b>Kapasitas Tersedia:</b> ${kapasitas_tersedia || "-"}<br><b>Harga/Kg:</b> ${formatRupiah(harga_per_kg)}<br><b>Total Harga:</b> ${formatRupiah(total_harga)}`,
          icon: "success",
          confirmButtonColor: "#198754",
          customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
        });

        fetchData();
      } catch (error) {
        console.error("Error updating berat sawit:", error);
        let errorMsg = "Terjadi kesalahan pada server.";
        if (error.response?.data?.error) {
          errorMsg = error.response.data.error;
        } else if (error.request) {
          errorMsg = "Tidak dapat menghubungi server. Periksa koneksi Anda.";
        }
        Swal.fire({ title: "Error", text: errorMsg, icon: "error", confirmButtonColor: "#198754" });
      }
    }
  };

  const handleDetail = (id) => {
    navigate(`/pabrikld/detail/${id}`);
  };

  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s.includes("terkirim") || s.includes("selesai") || s.includes("diterima")) {
      return <span className="badge bg-success-subtle text-success px-3 py-1.5 rounded-pill border border-success-subtle fw-semibold">Selesai</span>;
    }
    if (s.includes("jalan") || s.includes("proses") || s.includes("pengiriman")) {
      return <span className="badge bg-primary-subtle text-primary px-3 py-1.5 rounded-pill border border-primary-subtle fw-semibold">Proses</span>;
    }
    if (s.includes("batal") || s.includes("gagal") || s.includes("reject")) {
      return <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1.5 rounded-pill fw-semibold">Gagal</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-1.5 rounded-pill border border-warning-subtle fw-semibold text-capitalize">{status || "Pending"}</span>;
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  const formatRupiah = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return `Rp ${Number(num).toLocaleString("id-ID")}`;
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Isolasi Tabel Responsif */}
      <style>{`
        .custom-pabrik-table {
          width: 100% !important;
          border-collapse: collapse !important;
          table-layout: auto !important;
        }
        .custom-pabrik-table th,
        .custom-pabrik-table td {
          vertical-align: middle !important;
          white-space: nowrap !important;
        }
      `}</style>

      {/* Header */}
      <div className="header bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1" style={{ width: "100%", overflowX: "hidden" }}>
        {/* Sidebar */}
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/pabrikt") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.includes("/pabrikt") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Transactions" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikh" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikh" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/packaging.png" alt="Results" /> Hasil
            </div>
          </div>
        </div>

        {/* Main Content dengan constraint lebar penuh */}
        <div
          className="flex-grow-1 p-4"
          style={{
            width: "calc(100% - 240px)",
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Rincian Pembelian</h2>
              <p className="text-muted small mb-0">Pantau dan kelola transaksi masuk pembelian sawit dari petani.</p>
            </div>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="bg-white rounded-4 border shadow-sm p-4 w-100" style={{ minWidth: 0 }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h4 className="fw-bold text-success mb-1">Daftar Transaksi Pembelian</h4>
                <span className="text-muted small">Total: {purchaseData.length} transaksi</span>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data transaksi...</p>
              </div>
            ) : currentPurchaseData && currentPurchaseData.length > 0 ? (
              <>
                <div className="table-responsive w-100" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0 custom-pabrik-table" style={{ minWidth: "1000px" }}>
                    <thead className="table-light">
                      <tr className="text-secondary small fw-semibold">
                        <th className="text-center py-3 px-2" style={{ width: "50px", borderTopLeftRadius: "10px" }}>No</th>
                        <th className="text-center py-3 px-3" style={{ width: "140px" }}>Tracking ID</th>
                        <th className="py-3 px-3" style={{ width: "180px" }}>Nama Petani</th>
                        <th className="text-end py-3 px-3" style={{ width: "130px" }}>Berat Akhir</th>
                        <th className="text-center py-3 px-3" style={{ width: "120px" }}>Tgl Kirim</th>
                        <th className="text-center py-3 px-3" style={{ width: "120px" }}>Tgl Terima</th>
                        <th className="text-center py-3 px-3" style={{ width: "120px" }}>Status</th>
                        <th className="text-end py-3 px-3" style={{ width: "150px" }}>Total Biaya</th>
                        <th className="text-center py-3 px-3" style={{ width: "170px", borderTopRightRadius: "10px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPurchaseData.map((item, index) => (
                        <tr key={`transaksi-${item.tracking_id || item.id || index}`}>
                          <td className="text-center fw-bold text-muted px-2">
                            {startIndex + index + 1}
                          </td>
                          <td className="text-center font-monospace px-3">
                            <span className="badge bg-light text-dark border px-2 py-1">
                              {item.tracking_id || "-"}
                            </span>
                          </td>
                          <td className="fw-semibold text-dark text-capitalize px-3">
                            {item.nama_petani || "-"}
                          </td>
                          <td className="text-end font-monospace text-success fw-bold px-3">
                            {item.berat_akhir_sawit ? `${formatNumber(item.berat_akhir_sawit)} kg` : "-"}
                          </td>
                          <td className="text-center text-muted small px-3">
                            {formatToWIB(item.tanggal_pengiriman)}
                          </td>
                          <td className="text-center text-muted small px-3">
                            {formatToWIB(item.tanggal_diterima)}
                          </td>
                          <td className="text-center px-3">
                            {getStatusBadge(item.status)}
                          </td>
                          <td className="text-end font-monospace text-primary fw-bold px-3">
                            {formatRupiah(item.total_biaya)}
                          </td>
                          <td className="text-center px-3">
                            <div className="d-flex justify-content-center gap-2">
                              <button
                                className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                                style={{
                                  color: "#198754",
                                  borderColor: "#198754",
                                  backgroundColor: "#ffffff",
                                  borderWidth: "1.5px",
                                  borderStyle: "solid",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#198754";
                                  e.currentTarget.style.color = "#ffffff";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "#ffffff";
                                  e.currentTarget.style.color = "#198754";
                                }}
                                onClick={() => handleDetail(item.tracking_id)}
                              >
                                Detail
                              </button>
                              <button
                                className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                                style={{
                                  backgroundColor: "#198754",
                                  borderColor: "#198754",
                                  color: "#ffffff",
                                  borderWidth: "1.5px",
                                  borderStyle: "solid",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#157347";
                                  e.currentTarget.style.borderColor = "#157347";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "#198754";
                                  e.currentTarget.style.borderColor = "#198754";
                                }}
                                onClick={() => openModal(item.tracking_id)}
                              >
                                Update
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <nav className="mt-4">
                    <ul className="pagination justify-content-end mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-start-pill"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={`page-${index + 1}`}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link shadow-none"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-end-pill"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-shopping-cart mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Transaksi Pembelian</h5>
                <p className="mb-0">Data pengiriman dan transaksi masuk dari petani akan muncul di sini.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PabrikT;